import groupIcon from '@iconify/icons-material-symbols/groups-rounded';
import coursesIcon from '@iconify/icons-material-symbols/menu-book-rounded';
import helpIcon from '@iconify/icons-material-symbols/help-rounded';
import settingsIcon from '@iconify/icons-material-symbols/settings-rounded';
import { Icon } from '@iconify/react';
import React from 'react';

import { PATH_DASHBOARD } from 'routes/paths';
import starIcon from '@iconify/icons-material-symbols/grade-rounded';
import { APP_ROLES } from 'utils/roles';

const sidebarConfig = [
    {
        subheader: '',
        items: [
            {
                title: 'courses',
                path: PATH_DASHBOARD.courses.root,
                icon: <Icon icon={coursesIcon} width='48' height='48' />,
            },
            {
                title: 'scores',
                path: PATH_DASHBOARD.scores.root,
                icon: <Icon icon={starIcon} width='48' height='48' />,
            },
            {
                title: 'settings',
                path: PATH_DASHBOARD.user.root,
                icon: <Icon icon={settingsIcon} width='48' height='48' />,
            },
            {
                title: 'docs',
                path: PATH_DASHBOARD.docs.root,
                icon: <Icon icon={helpIcon} width='48' height='48' />,
            },
            {
                title: 'groups',
                accessibleRoles: [APP_ROLES.SUPER_ADMIN, APP_ROLES.ADMIN, APP_ROLES.DESTYTOJAS],
                path: PATH_DASHBOARD.groups.root,
                icon: <Icon icon={groupIcon} width='48' height='48' />,
            },
            {
                title: 'manage_groups',
                accessibleRoles: [APP_ROLES.SUPER_ADMIN, APP_ROLES.ADMIN],
                path: PATH_DASHBOARD.manageGroups.root,
                icon: <Icon icon={groupIcon} width='48' height='48' />,
            },
            {
                title: 'admin',
                accessibleRoles: [APP_ROLES.SUPER_ADMIN, APP_ROLES.ADMIN],
                path: PATH_DASHBOARD.admin.root,
                icon: <Icon icon={groupIcon} width='48' height='48' />,
            },
        ],
    },
];

export default sidebarConfig;
